/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps*/
import React, { useState, useEffect } from 'react'
import Page from '../../Components/Page/Page'
import { useKeycloak } from '@react-keycloak/web'
import { FaqsService } from '../../Service/FaqsService';
import {
  Divider,
  Button,
  Form,
  Input,
  Select,
  notification
} from 'antd';

import { handleLogError, ErrorPage, openNotificationWithIcon } from '../../Helpers/Helpers';
import { useTranslate } from '../../Translate';
import { useNavigate, useParams } from 'react-router-dom';
import languages from '../../utils/languages';
import ReactQuill from 'react-quill';
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },

  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },

  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 2,
      offset: 2,
    },
    sm: {
      span: 8,
      offset: 8,
    },
  },
};


const Faq = (props) => {
  var sel_cats = "";
  //gestione della lingua
  const i18n = useTranslate();
  const { t } = i18n;
  const { id } = useParams();
  const [loading, setLoading] = useState(false)
  const [faq, setFaq] = useState([])
  const [cats, setCats] = useState([])
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { keycloak } = useKeycloak()
  const [lingua, setLingua] = useState([])

  const getDataLanguages = () => {
    var response = [];
    languages.forEach((language) => {
      response.push(<Option key={language.id} value={language.id}>{t(language.description)}</Option>);
    });
    setLingua(response);
  }
  const handleBack = () => {
    navigate('/admin/faqs');
  }

  useEffect(() => {
    getDataLanguages()
    getData()
  }, [])



  const onFinish = (values) => {

    id != undefined ? handleSendUpdate(values) : handleSendSave(values);
  };


  const getData = async () => {
    setLoading(true);
    try {
      const lk_cats = [];
      const response_cats = await FaqsService.getCatFaqs()
      response_cats.data.map((cat) => {
        lk_cats.push(<Option value={cat.id} key={cat.id}>{cat.titolo.trim()}</Option>);
        return cat;
      });
      setCats(lk_cats)
      if (id) {
        const response = await FaqsService.getFaqById(id)
        setFaq(response.data);
        console.log(response.data)
        /*setto i campidel form*/
        form.setFieldsValue({
          domanda: response.data.domanda,
          risposta: response.data.risposta,
          languageid: response.data.languageid != 0 ? response.data.languageid : "",
          catFaq: response.data.catFaq != null ? response.data.catFaq.id : "",
        });
      }
    } catch (error) {
      handleLogError(error);
    }
    setLoading(false);

  }

  const handleSendUpdate = async (data) => {
    try {
      setLoading(true);
      data["id"] = id;
      data["catFaq"]={
        id: data["catFaq"]
      }
      const response = await FaqsService.updateFaq(keycloak.token, data)
      if (response.status == 200) {
        openNotificationWithIcon('success', "Success", "Faq salvata con successo!");
        navigate('/admin/faqs');
      } else if (response.status == 400 || response.status == 404) {
        openNotificationWithIcon('warning', "Warning", "Faq non esistente!");
        
      } else {
        openNotificationWithIcon('error', "Errore", "Errore nell'aggiornamento della faq!");
      }
    } catch (error) {
      handleLogError(error);
      setLoading(false);
    }
    setLoading(false);
  }

  const handleSendSave = async (data) => {
    try {
      setLoading(true);
      data["catFaq"]={
        id: data["catFaq"]
      }
      const response = await FaqsService.saveFaq(keycloak.token, data)
      if (response.status == 200) {
        openNotificationWithIcon('success', "Success", "Faq salvata con successo!");
        navigate('/admin/faqs');
      } else if (response.status == 400 || response.status == 404) {
        openNotificationWithIcon('warning', "Warning", "Faq non esistente!");
      } else {
        openNotificationWithIcon('error', "Errore", "Errore nel salvataggio della faq!");
      }
    } catch (error) {
      handleLogError(error);
      setLoading(false);
    }
    setLoading(false);
  }
  return (
    <Page loading={loading} inner>
      <>
        <Divider orientation="left" orientationMargin="0" style={{ color: '#e61e1e' }}>{id == null ? t("new2") + " FAQ" : t("edit")+ " FAQ"}</Divider>
        <Form
          {...formItemLayout}
          form={form}
          layout="vertical"
          name="faq"
          onFinish={onFinish}
          scrollToFirstError
        >
          <Form.Item
            label={t('question')}
            name="domanda"
            rules={[
              {
                required: true,
                message: t('ckQuestion'),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t('reply')}
            name="risposta"
            rules={[
              {
                required: true,
                message: t('ckReply'),
              },
            ]}
          >
             <ReactQuill theme="snow"  />
            {/* <Input /> */}
          </Form.Item>
          <Form.Item
            label={t("language")}
            name="languageid"
            rules={[
              {
                required: true,
                message: t('ckLanguage'),
              },
            ]}
          >
            <Select
              autoComplete="none"
              showSearch
              style={{
                width: '100%',
              }}
              filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
              }
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            >
              {lingua}
            </Select>
          </Form.Item>
          <Form.Item
            label={t('category')}
            name="catFaq"
            rules={[
              {
                required: true,
                message: t('ckCategory'),
              },
            ]}
          >
            <Select
              autoComplete="none"
              showSearch
              style={{
                width: '100%',
              }}
              filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase().trim())
              }
              optionFilterProp="children"
              defaultValue={sel_cats}
              filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase().trim())}
              allowClear
            >
              {cats}
            </Select>
          </Form.Item>
          <Form.Item></Form.Item>
          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              {t("save")}
            </Button>
            <Button
              style={{
                margin: '0 8px',
              }}
              onClick={handleBack}
            >
              {t("cancel")}
            </Button>
          </Form.Item>

        </Form>
      </>
    </Page>
  )
}

export default Faq